import { db } from '../firebaseConfig';
import { collection, query, where, getDocs, doc, getDoc } from 'firebase/firestore';

/**
 * Hakee kaikki varauskalenterit tälle taloyhtiölle ('talonyhtiöt': array-contains companyId).
 */
export async function fetchCalendarsForCompany(companyId) {
  if (!companyId) return [];
  const q = query(
    collection(db, 'varauskalenterit'),
    where('talonyhtiöt', 'array-contains', companyId)
  );
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

/**
 * Hakee taloyhtiön oletusvärin talonyhtiöt-kokoelmasta (kenttä: 'oletusväri').
 */
export async function fetchCompanyColor(companyId) {
  if (!companyId) return null;
  const ref = doc(db, 'talonyhtiöt', companyId);
  const s = await getDoc(ref);
  return s.exists() ? (s.data().oletusväri || null) : null;
}
